'use strict';

import scrollToElement from 'helpers/scrollToElement';
import accessibility from 'helpers/accessibility';

var AddToBasketMadeToMeasureForm = function(container) {

  var termsAcceptedBtn = container.querySelector('input[name="termsAccepted"]'),
    addToBasketBtn = container.querySelector('.button'),
    termsAndConditionsTitle = container.querySelector('#terms-and-conditions-title'),
    termsNotAcceptedError = container.querySelector('#terms-not-accepted-error'),
    basketError = container.querySelector('#basket-error'),
    tryAgainLink = container.querySelector('#basket-error .m2m-try-again-link'),
    termsAndConditionsLink = container.querySelector('.m2m-read-terms-and-conditions-content a');

  function setup() {

    if (!termsAcceptedBtn.checked) {
      addToBasketBtn.classList.add('button--inactive');
    }

    termsAcceptedBtn.addEventListener('change', () => {
      if (termsAcceptedBtn.checked) {
        addToBasketBtn.classList.remove('button--inactive');
        termsNotAcceptedError.classList.add('u-hidden');
      } else {
        addToBasketBtn.classList.add('button--inactive');
      }
    });

    window.addEventListener('beforeunload', () => {
      termsAcceptedBtn.checked = false;
    });

    if (basketError) {
      container.appendChild(basketError)
      if (tryAgainLink) {
        tryAgainLink.addEventListener('click', (e) => {
          e.preventDefault();
          addToBasketBtn.click();
        });
      }
      let alertText = basketError.textContent;
      scrollToElement(termsAcceptedBtn);
      accessibility.alert(alertText, 100);
    }
    if (termsAndConditionsLink) {
      termsAndConditionsLink.setAttribute("target", "_blank");
      termsAndConditionsLink.setAttribute("rel", "noopener noreferrer");
    }
  }

  if (termsAcceptedBtn && addToBasketBtn && termsAndConditionsTitle && termsNotAcceptedError) {
    setup();
  }
}

function init() {
  var container = document.querySelector('.m2m-add-to-basket-form');
  if (container) {
    new AddToBasketMadeToMeasureForm(container);
  }
}

if ('querySelector' in document) {
  init();
}

export default AddToBasketMadeToMeasureForm

